// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"museum"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 3H7V8.55556L3 9V21H21V7L17 7.44444V3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17 21V14H21V21H17Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M11 11.998H11.0039V12.002H11V11.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7 11.998H7.00391V12.002H7V11.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7 11.998H7.00391V12.002H7V11.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M17 21V14H21V21H17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 6.92V3H7V7.9M3 9V21H21V7L3 9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MuseumIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'museum',
    ref,
    icon: element,
  },
));

MuseumIcon.displayName = 'MuseumIcon';

export default MuseumIcon;
